import escapeHtml from "@/modules/escape-html";
import merge from "lodash.merge";
import { marked } from "marked";
import { computed, MaybeRefOrGetter, unref } from "vue";

export const useMarkdownHTML = (
  text: MaybeRefOrGetter<string>,
  options?: {
    escapeHTML?: boolean;
    transformBeforeLastBreak?: boolean;
  }
) => {
  const mergedOptions = merge(
    {
      escapeHTML: true,
      transformBeforeLastBreak: false,
    },
    options ?? {}
  );
  const html = computed(() => {
    const unrefText = typeof text === "function" ? text() : unref(text);
    if (!unrefText) {
      return "";
    }
    const content = (
      mergedOptions.escapeHTML ? escapeHtml(unrefText) : unrefText
    ).trim();
    // content = prefixContent(content);
    if (mergedOptions.transformBeforeLastBreak) {
      const lastEnterIndex = content.lastIndexOf("\n");
      if (lastEnterIndex === -1) {
        return content;
      } else {
        const markdownPart = content.substring(0, lastEnterIndex);
        const rawPart = content.substring(lastEnterIndex + 1);
        return (marked.parse(markdownPart) + rawPart) as string;
      }
    } else {
      return marked.parse(content) as string;
    }
  });
  return { html };
};
